import { DropdownMenu, FormField } from 'taboola-ultimate-ui';
import { withIndication } from 'modules/errors/components';
import { useComparisonOperators } from 'modules/push-api/hooks/useComparisonOperators';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './comparisonOperatorDropdown.module.scss';

const FormFieldWithIndication = withIndication(FormField);

export const ComparisonOperatorDropdown = ({ selectedComparisonOperator }) => {
    const { options, comparisonOperator, setComparisonOperatorOnChange } =
        useComparisonOperators(selectedComparisonOperator);

    return (
        <FormFieldWithIndication
            inputId={`${selectedComparisonOperator}-input`}
            containerClass={styles['field-container']}
            label={
                <FormattedMessage id="push.api.create.settings.comparison-operator.label" defaultMessage="Comparison" />
            }
            labelClass={styles['label']}
        >
            <div className={styles['field']}>
                <DropdownMenu
                    required
                    id={`${selectedComparisonOperator}-input`}
                    selectedValueObject={{
                        value: comparisonOperator,
                    }}
                    options={options}
                    onChange={setComparisonOperatorOnChange}
                    searchable
                    aria-label="comparison-operator-dropdown"
                    className={styles['dropdown-menu']}
                />
            </div>
        </FormFieldWithIndication>
    );
};
